import { type FC } from "react";
import { type WeightData } from "~/domains/product/types/WeightData";
import { WeightFormat } from "~/domains/product/components/WeightFormat";
import { useTranslation } from "react-i18next";
import { Param } from "~/features/orders/common/components/v2/Params";

interface PackageNumberProps {
  index: number;
  totalCount: number;
}

export const PackageNumberInformation: FC<PackageNumberProps> = ({ index, totalCount }) => {
  const { t } = useTranslation();
  return (
    <Param
      label={t("cartPage.shipmentDetails.table.header.packageNumber")}
      value={t("cartPage.shipmentDetails.table.header.packageNumberValues", {
        index: index + 1,
        totalCount: totalCount,
      })}
    />
  );
};

interface PackageWeightProps {
  weight: WeightData;
}

export const PackageWeightInformation: FC<PackageWeightProps> = ({ weight }) => {
  const { t } = useTranslation();
  return (
    <Param label={t("cartPage.shipmentDetails.table.header.packageWeight")} value={<WeightFormat weight={weight} />} />
  );
};
